export default __webpack_public_path__ + "static/media/autrepompe.f7fdaa94.png";